import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import isEmpty from 'lodash/isEmpty';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import MaterialSelect from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import styles from './Select.scss';

const Select = ({
    afterChange,
    className,
    defaultValue,
    emptyMessage,
    label,
    options,
    variant,
    fullWidth,
    ...props
}) => {
    const [selectedOption, setSelectedOption] = useState(defaultValue);

    function handleChange (event) {
        const selected = event.target.value;
        setSelectedOption(selected);
        afterChange(selected);
    }

    return (
        <FormControl
            className={classnames(styles.selectWrapper, className)}
            fullWidth={fullWidth}
            variant={variant}
        >
            <InputLabel htmlFor={label} className={styles.label}>
                {label}
            </InputLabel>

            <MaterialSelect
                id={label}
                className={
                    classnames(
                        styles.select,
                        {[styles.selectFilled]: variant === 'filled'}
                    )
                }
                displayEmpty
                onChange={handleChange}
                renderValue={value =>
                    isEmpty(value) ?
                        emptyMessage :
                        options.find(option => option.value === value).display
                }
                value={selectedOption}
                variant={variant}
                { ...props }
            >
                {options.map((option, index) =>
                    <MenuItem
                        key={index}
                        value={option.value}
                        aria-label={option.display}
                    >
                        {option.display}
                    </MenuItem>
                )}
            </MaterialSelect>
        </FormControl>
    );
};

Select.propTypes = {
    afterChange: PropTypes.func,
    defaultValue: PropTypes.oneOfType([
        PropTypes.number,
        PropTypes.string
    ]),
    emptyMessage: PropTypes.string,
    label: PropTypes.string,
    options: PropTypes.arrayOf(PropTypes.shape({
        display: PropTypes.node.isRequired,
        value: PropTypes.oneOfType([
            PropTypes.number,
            PropTypes.string
        ]).isRequired
    })).isRequired,
    variant: PropTypes.string,
    fullWidth: PropTypes.bool
};

Select.defaultProps = {
    afterChange: () => {},
    defaultValue: '',
    emptyMessage: '',
    label: '',
    variant: 'filled',
    fullWidth: true
};

export default Select;
